"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var param_1 = require("../conversions/param");

var sha3_1 = require("../libs/sha3");

var forge = require("node-forge");

var blake = require("../libs/blake2b");

var string_bytes_1 = require("../conversions/string-bytes");

exports._hashChain = function (input) {
  return param_1._fromIn(exports.keccak(exports.blake2b(param_1._fromIn(input))));
};

exports.sha256 = function (input) {
  var md = forge.md.sha256.create();
  md.update(string_bytes_1.bytesToString(input, 'raw'));
  return string_bytes_1.stringToBytes(md.digest().getBytes(), 'raw');
};

exports.blake2b = function (input) {
  return blake.blake2b(param_1._fromIn(input), null, 32);
};

exports.keccak = function (input) {
  return param_1._fromIn(sha3_1.keccak256.array(param_1._fromIn(input)));
};

exports.hmacSHA256 = function (message, key) {
  var hmac = forge.hmac.create();
  hmac.start('sha256', string_bytes_1.bytesToString(param_1._fromIn(key), 'raw'));
  hmac.update(string_bytes_1.bytesToString(param_1._fromIn(message), 'raw'));
  return string_bytes_1.stringToBytes(hmac.digest().getBytes(), 'raw');
};